import actionTypes from '../constants/action-types';

const setEmptyPage = (emptyPage) => ({
  type: actionTypes.SET_EMPTY_PAGE,
  payload: {
    emptyPage,
  },
});

export default setEmptyPage;
